import React from 'react'
import './Experts.css'
import ContactForm from '../../Contact/ContactForm';
import { FaChevronRight } from 'react-icons/fa6'
import { FaPhoneAlt } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'
import QatarFlag from '../../../../assets/img/qatar_flag.webp'
import IndiaFlag from '../../../../assets/img/india_flag.webp'
import UaeFlag from '../../../../assets/img/uae_flag.svg'
import BahrainFlag from '../../../../assets/img/bahrain_flag.svg'

function Experts() {
  return (
    <section className='expt-sec'>
      <div className='container'>
        <div className='oex-sec'>
          <h5>Get in Touch with</h5>
          <h3>Our Experts</h3>
          <ul>
            <li>
              <div className='expt-icon'><FaPhoneAlt /></div>
              <h4>Phone:</h4>
              <p><img src={QatarFlag} alt='Qatar flag' width={24} height={16} loading="lazy" /><a href='tel:+974 4466 1996'>+974 4466 1996</a></p>
              <p><img src={UaeFlag} alt='UAE flag' width={24} height={16} loading="lazy" /><a href='tel:+971 52609 9677'>+971 52609 9677</a></p>
              <p><img src={IndiaFlag} alt='India flag' width={24} height={16} loading="lazy" /><a href='tel:+91 98881 25428'>+91 98881 25428</a></p>
              <p><img src={BahrainFlag} alt='Bahrain flag' width={24} height={16} loading="lazy" /><a href='tel:+973 3353 6660'>+973 3353 6660</a></p>
            </li>
            <li>
              <div className='expt-icon'><MdEmail /></div>
              <h4>Email:</h4>
              <p><a href='mailto:projects@360-bytes.com'>projects@360-bytes.com</a></p>
            </li>
          </ul>
        </div>
        <div className='expt-frm'>
          <ContactForm />

        </div>
      </div>
    </section>
  )
}

export default Experts
